var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-input-modal" },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            [
              _c("span", [_vm._v("Regulamento")]),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.onClick } },
                [_vm._v("\n        " + _vm._s(_vm.button) + "\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SdzModal",
            {
              ref: "sdzModal",
              attrs: {
                "close-icon": true,
                "hide-cancel-button": "",
                "hide-confirm-button": "",
                width: "550",
                title: "Regulamento",
                "confirmation-event": "onConfirm",
              },
              on: { close: _vm.close },
            },
            [
              _c("v-card-text", [
                _c("div", { staticClass: "d-flex justify-center" }, [
                  _c("object", {
                    attrs: {
                      data: `${_vm.terms}#toolbar=1&navpanes=0`,
                      type: "application/pdf",
                      height: "320",
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }